export async function loadBasic(engine, refresh = true) {
    const { loadBaseMover } = await import("@tsparticles/move-base"), { loadCircleShape } = await import("@tsparticles/shape-circle"), { loadColorUpdater } = await import("@tsparticles/updater-color"), { loadOpacityUpdater } = await import("@tsparticles/updater-opacity"), { loadOutModesUpdater } = await import("@tsparticles/updater-out-modes"), { loadSizeUpdater } = await import("@tsparticles/updater-size");
    await loadBaseMover(engine, false);
    await loadCircleShape(engine, false);
    await loadColorUpdater(engine, false);
    await loadOpacityUpdater(engine, false);
    await loadOutModesUpdater(engine, false);
    await loadSizeUpdater(engine, false);
    await engine.refresh(refresh);
}
